'use strict';

var UserFbcExclusionRulesController = function UserFbcExclusionRulesController($scope, dataRetrieverService, userFbcExclusionRulesService) {
  dataRetrieverService.getDataRetriever('SYSTEM_STATUS_SCREEN', 'user-fbc-exclusion-rules-mode').setCustomSearchCriteriaRules([]);
  $scope.customRemove = function (rowsToBeRemovedFromServer) {
    userFbcExclusionRulesService.remove(rowsToBeRemovedFromServer);
  };
  $scope.customSave = function (rows) {
    return userFbcExclusionRulesService.save(rows);
  };
};
UserFbcExclusionRulesController.$inject = ['$scope', 'DataRetrieverService', 'UserFbcExclusionRulesService'];
module.exports = UserFbcExclusionRulesController;